define('kitpDetailView',[
  'module',
  'kitpCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!kitpDetailTabTpl',
  'settings'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  Settings
) {
  'use strict';

  var KitpDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.currentCAccountSecId = Settings.get('currentCAccount').secId;
      return templateData;
    },

    onShow: function() {
      $.material.init();
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        kitpModel: this.model
      });
      createEditView.show({
        title: _.i18n('kitp.edit')
      });
    }

  });

  module.exports = KitpDetailView;
});
